export default "__VITE_ASSET__DAYB4h4N__"